import styled from "styled-components"
import Dropdown from "../../common/Dropdown"
import { useLeague } from "../../../context/useLeague"
import TeamService from "../../../services/team"
import HelperService from "../../../services/helper"
import useNotify from "../../../context/useNotify"
import { FC, useState } from "react"
import { isImageSquare } from "../../../utils/formatString"
import { faHourglass } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LineupPositionDTO, UpdateTeamDTO } from "../../../models/team"

interface Props {
  handleClickRelease: () => void
  handleClickContractsInfo: () => void
}

const ManagersArea: FC<Props> = ({
  handleClickRelease,
  handleClickContractsInfo,
}) => {
  const { userTeam, league, getLeagueById, lineup } = useLeague()
  const notify = useNotify()

  // Data
  const [newLiveLink, setNewLiveLink] = useState(userTeam?.liveLink ?? "")
  const [newImage, setNewImage] = useState(userTeam?.image ?? "")

  // API
  const updateTeam = async (
    liveLink: string,
    image: string,
    lineup: LineupPositionDTO[]
  ) => {
    if (!userTeam || !league) {
      return
    }
    try {
      const dto: UpdateTeamDTO = { liveLink, image, lineup }
      await TeamService.updateTeam(userTeam._id, dto)
      notify.success("Team updated successfully.")
      getLeagueById(league._id)
    } catch (error) {
      console.log("An error occurred while updating team: ", error)
      HelperService.showNotfyErr(
        notify,
        error,
        "An error occurred while updating team."
      )
    }
  }

  // Methods
  const handleEditLiveLink = (e: any) => {
    if (!userTeam) {
      return
    }
    e.preventDefault()
    const lineupDTO: LineupPositionDTO[] = lineup.map((el) => ({
      user: el.user._id,
      position: el.position,
      isAny: el.isAny,
    }))
    updateTeam(newLiveLink, userTeam.image, lineupDTO)
  }

  const handleEditImage = async (e: any) => {
    if (!userTeam) {
      return
    }
    e.preventDefault()
    const square = await isImageSquare(newImage)
    if (!square) {
      notify.error("Image must be square.")
      return
    }
    const lineupDTO: LineupPositionDTO[] = lineup.map((el) => ({
      user: el.user._id,
      position: el.position,
      isAny: el.isAny,
    }))
    updateTeam(userTeam.liveLink, newImage, lineupDTO)
  }

  const handleSelectFixture = (selectedOption: any) => {
    if (!selectedOption) {
      return
    }
  }

  return (
    <Wrapper>
      <Container className="mt-1">
        {/* manager contracts */}
        <h5 className="m-0 p-0 ps-2 heading fw-bold">Manage Contracts</h5>
        <SubContainer>
          <div className="col d-flex justify-content-center align-items-center  m-0 p-0 w-100 gap-3 ">
            <Button
              className="btn btn-dark btn-sm  "
              onClick={handleClickContractsInfo}
            >
              View Contracts Info
            </Button>
            <Button
              className="btn btn-dark btn-sm "
              onClick={handleClickRelease}
            >
              Release Player
            </Button>
          </div>
        </SubContainer>
        {/* call time */}
        <h5 className="m-0 p-0 ps-2 mt-2  heading fw-bold">Call Time</h5>
        <SubContainer>
          <div
            className="row w-100 d-flex flex-column justify-content-between align-items-center m-0 p-0 gap-3 h-100"
            style={{ maxWidth: "410px" }}
          >
            <div className="col d-flex justify-content-start align-items-center  m-0 p-0 w-100 gap-3 h-100">
              {/* select fixture text*/}
              <p className="w-100 d-flex justify-content-center align-items-center h-100 m-1">
                Select Fixture
              </p>
              {/* fixtures dropdown */}
              <div className="w-100  d-flex justify-content-center align-items-center ">
                <div style={{ maxWidth: "200px", width: "100%" }}>
                  <Dropdown
                    options={[]}
                    onSelect={handleSelectFixture}
                    text="Coming soon"
                  />
                </div>
              </div>
            </div>
            <div className="col d-flex justify-content-center align-items-center  m-0 p-0 w-100 gap-3 h-100">
              {/* call time text */}
              <p className="w-50 d-flex justify-content-center align-items-center h-100 m-1">
                Call Time
              </p>
              {/* call time button */}
              <div className="w-50 d-flex justify-content-center align-items-center ">
                <Button
                  className="btn btn-dark btn-sm "
                  //   onClick={}
                >
                  <FontAwesomeIcon icon={faHourglass} /> Coming Soon
                </Button>
              </div>
            </div>
            <div className="col d-flex justify-content-start align-items-center  m-0 p-0 w-100 gap-3 h-100 text-center">
              {/* times remaining text */}
              <p className="w-50 d-flex justify-content-center align-items-center h-100 m-1">
                Calls Remaining
              </p>
              {/* calls remaining value */}
              <p className="w-50 d-flex justify-content-center align-items-center h-100 m-1">
                0
              </p>
            </div>
          </div>
        </SubContainer>
        {/* edit club */}
        <h5 className="m-0 p-0 ps-2 mt-2  heading fw-bold">Edit Club</h5>
        <SubContainer>
          {/* edit club name */}
          <form className="d-flex flex-column justify-centent-center align-items-center w-100">
            <div style={{ maxWidth: "450px" }}>
              <label>Edit club name</label>
              <div className="form-group d-flex  gap-2">
                <Input
                  type="text"
                  className="form-control bg-dark text-light"
                  placeholder="Coming soon"
                ></Input>
                <Button
                  className="btn btn-dark p-0"
                  style={{ maxWidth: "80px" }}
                  disabled
                >
                  Edit
                </Button>
              </div>
              {/* edit live link */}
              <label className="mt-2">Edit live link</label>
              <div className="form-group d-flex gap-2">
                <Input
                  type="text"
                  className="form-control bg-dark text-light"
                  placeholder="New live link"
                  value={newLiveLink}
                  onChange={(e) => setNewLiveLink(e.target.value)}
                ></Input>
                <Button
                  className="btn btn-dark p-0"
                  style={{ maxWidth: "80px" }}
                  onClick={handleEditLiveLink}
                >
                  Edit
                </Button>
              </div>
              {/* edit club crest */}
              <label className="mt-2">Edit club crest</label>
              <div className="form-group d-flex  gap-2">
                <Input
                  type="text"
                  className="form-control bg-dark text-light"
                  placeholder="New image url"
                  value={newImage}
                  onChange={(e) => setNewImage(e.target.value)}
                ></Input>
                <Button
                  className="btn btn-dark p-0"
                  style={{ maxWidth: "80px" }}
                  onClick={handleEditImage}
                >
                  Edit
                </Button>
              </div>
            </div>
          </form>
        </SubContainer>
      </Container>
    </Wrapper>
  )
}

export default ManagersArea

const Wrapper = styled.div`
  margin-bottom: 1rem;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

const Container = styled.div`
  background: linear-gradient(120deg, #000000ff 60%, #040a2cff 100%);
  padding: 1rem;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  border-radius: 8px;
  gap: 0.5rem;
  border: 2px solid #5fa8e6;
  box-shadow: 0 0 5px 1px #00eaff;
  max-width: 400px;
`

const SubContainer = styled.div`
  background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 1rem;
  border-radius: 8px;
  border: 2px solid #5fa8e6;
  box-shadow: 0 0 8px 1px #00eaff;
`

const Input = styled.input`
  outline: none;
  border: 2px solid #5fa8e6;
  border-radius: 8px;
  background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
  color: #fff;
  padding: 0.5rem;
  box-shadow: 0 0 8px 1px #00eaff;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }
  
  &:focus {
    box-shadow: 0 0 12px 2px #00eaff;
  }
`

const Button = styled.button`
  width: 100%;
  text-align: center;
  max-width: 200px;
  border: 2px solid #5fa8e6;
  border-radius: 8px;
  background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
  color: #fff;
  padding: 0.5rem;
  cursor: pointer;
  box-shadow: 0 0 8px 1px #00eaff;
  transition: all 0.3s ease;
  
  &:hover:not(:disabled) {
    box-shadow: 0 0 12px 2px #00eaff;
    background: linear-gradient(120deg, #2d3145 60%, #232632 100%);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
